import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { ROUTES } from '@/constants';

/**
 * Blocks app routes until the authenticated user has an organization.
 * Settings (cadastro da empresa) remains reachable without this gate.
 */
export function RequireOrganization() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user?.organizationId) {
    return (
      <Navigate
        to={ROUTES.SETTINGS}
        replace
        state={{ from: location.pathname, needsOrganization: true }}
      />
    );
  }

  return <Outlet />;
}
